<h1 class="visually-hidden">Careers at MALtech Join Our Innovative Team</h1>

<div class="bg-light py-6">
  <div class="container">

    <!-- ================= HERO SECTION ================= -->
    <section class="hero-section py-3 py-md-4 mb-2">





      <div class="hero-container py-0">

        <h1 class="hero-title mt-0 mb-2">
  Careers at MALtech Join Our Innovative Team </h1>


        <p class="hero-description para mt-0 mb-3">
          Join our mission to transform businesses through technology. At MALtech,
          you'll work with global teams, solve complex challenges, and shape the future of innovation.
        </p>

        <div class="hero-buttons mt-1">


<button
  type="button"
  class="hero-btn btn-outline"
  (click)="scrollToSection($event, 'open-roles')">
  View Open Roles
</button>

          <a
        routerLink="/contact"
        href="/contact"
        class="get-started-btn hero-btn btn-outline"
        rel="noopener noreferrer"
        aria-label="Let's Work Together"
      >
        Let's Work Together
      </a>

          <!-- <a href="https://candidate.speedexam.net/register.aspx?site=maltechsolutions"
             target="_blank"
             class="hero-btn btn-outline">
            Campus Registration
          </a> -->
          <a routerLink="/apply-job"
             href="/apply-job"
             class="hero-btn btn-outline">
            Apply Now
          </a>
        </div>
      </div>
    </section>

    <!-- ================= WHO WE ARE ================= -->
    <section class="section2 pt-0 mt-n3">


      <div class="section2-container">
        <h2 class="section2-title head2 mt-0 mb-2">Who we are</h2>

      <div class="px-0 px-md-3">
        <p class="section2-description para px-0">

         MALtech is a global IT solutions company specializing in Cloud, AI, DevOps, Cybersecurity, 
         and Software Consulting. We partner with enterprises to deliver secure, scalable, and future-ready digital ecosystems. With a strong people-first culture, we empower our teams to innovate and solve complex challenges.
          Trusted worldwide, MALtech drives business transformation through technology, strategy, and innovation.
        </p>
      </div>
      </div>
    </section>

    <!-- ================= WHY JOIN ================= -->
    <section class="section3">
      <div class="section3-container">
        <h2 class="section3-title head2">Why Join MALtech?</h2>

        <div class="section3-cards">
          <div class="section3-card" *ngFor="let card of secCards">
            <div class="card-icon-container">
              <i [class]="'bi ' + card.iconClass"></i>
            </div>

            <div class="card-text-container">
              <h3 class="card-title">{{ card.title }}</h3>
              <p class="card-description para">{{ card.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ================= WHAT WE DO ================= -->
    <section class="section4">
      <div class="section4-container">
        <h2 class="section4-title head2">What We Do</h2>

        <div class="section4-cards">
          <div class="section4-card" *ngFor="let card of whatWeDoCards">
            <img [src]="card.image"
                 [alt]="card.title"
                 class="card-image"
                 loading="lazy" />

            <div class="card-content">
              <h3 class="card-title">{{ card.title }}</h3>
              <p class="card-description">{{ card.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

<section class="section5" id="open-roles">

  <!-- Section Title -->
  <h2 class="section5-title head2">
    Open Positions
  </h2>

  <!-- Job Category Tabs -->
  <div class="tabs-container">

    <!-- Left Arrow -->
    <button
      *ngIf="showLeftArrow"
      type="button"
      class="tab-scroll-btn"
      (click)="scrollTabs('left')"
      aria-label="Scroll tabs left">
      <i class="bi bi-chevron-left"></i>
    </button>

    <!-- Tabs -->
    <div
      #tabsWrapper
      class="tabs-wrapper"
      (scroll)="onTabsScroll()">

      <div class="tabs">

        <div
          class="tab"
          *ngFor="let tab of tabs"
          [class.active]="activeTab === tab.key"
          (click)="setActiveTab(tab.key)">

          <span class="tab-label">
            {{ tab.label | titlecase }}
          </span>

          <hr />

        </div>

      </div>

    </div>

    <!-- Right Arrow -->
    <button
      *ngIf="showRightArrow"
      type="button"
      class="tab-scroll-btn"
      (click)="scrollTabs('right')"
      aria-label="Scroll tabs right">
      <i class="bi bi-chevron-right"></i>
    </button>

  </div>


  <!-- Jobs -->
  <div
    class="jobs"
    *ngIf="activeTab && jobs[activeTab]">

    <div
      class="job-card"
      *ngFor="let job of jobs[activeTab]">

      <div class="job-info">

        <h3 class="job-title">
          {{ job.title }}
        </h3>

        <p class="job-description">
          Experience:
          {{ job.min_experience }}–{{ job.max_experience }} yrs

          <span class="separator">|</span>

          Salary:
          {{ job.min_ctc }}–{{ job.max_ctc }} LPA
        </p>

      </div>

      <div class="apply-wrapper">

        <a
          class="apply-btn"
          [routerLink]="['/jobView']"
          [href]="'/jobView?jobId=' + job.id"
          [queryParams]="{ jobId: job.id }">
          Apply
        </a>

      </div>

    </div>

    <!-- No Jobs -->
    <div
      *ngIf="jobs[activeTab]?.length === 0"
      class="alert alert-info mt-3">

      No positions available in this category.

    </div>

  </div>

</section>
  </div>
</div>


<!-- ================= INTERNSHIP SECTION ================= -->
<div *ngIf="showInternshipSection" class="bg-color py-5">
  <div class="container">

    <h2 class="text-center fw-bold heading-color">Internship Opportunities</h2>
    <p class="text-center text-dark mt-2 px-3 ">
      Kickstart your career with our internship programs designed for fresh talent.
       Explore roles that offer hands-on experience and real-world learning.
    </p>

    <div class="row gy-4 justify-content-center mt-4">
      <div class="col-12 col-sm-6 col-md-4"
           *ngFor="let item of internships">

        <div class="intern-card p-4 text-center shadow-sm h-100 d-flex flex-column justify-content-between">
          <h4 class="fw-bold">{{ item.title }}</h4>

          <p class="text-dark mt-2 mb-4">
            Qualification: {{ item.qualification }}
          </p>

          <a class="btn apply-btn mt-auto text-decoration-none"
   [routerLink]="item.route"
   [href]="item.route">
  {{ item.btnText }}
</a>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- ================= PROBLEM STATEMENT SECTION ================= -->
<div class="problem-div">
  <h3 class="text-center fw-bold heading-color mb-5">
    Problem Statement Categories
  </h3>

  <div class="container">
    <div class="problems-card">

      <!-- ================= TAB HEADER ================= -->
    <div class="pill-tabs-header d-flex align-items-center">

  <!-- LEFT ARROW -->
  <button
    type="button"
    class="pill-scroll-btn btn rounded-circle d-flex align-items-center justify-content-center"
    *ngIf="showLeftArrow"
    (click)="scrollTabsLeft()"
    aria-label="Scroll left">
    <i class="bi bi-chevron-left"></i>
  </button>

  <!-- PILLS -->
  <div
    class="pill-tabs d-flex flex-nowrap overflow-auto flex-grow-1"
    #pillTabs
    (scroll)="onTabsScroll()">

    <button
      type="button"
      class="pill-tab btn"
      *ngFor="let tab of tabsProblemTabs"
      [class.active]="tab.id === tabsProblemActiveTab"
      (click)="tabsProblemSwitchTab(tab.id)">
      {{ tab.label }}
    </button>

  </div>

  <!-- RIGHT ARROW -->
  <button
    type="button"
    class="pill-scroll-btn btn rounded-circle d-flex align-items-center justify-content-center"
    *ngIf="showRightArrow"
    (click)="scrollTabsRight()"
    aria-label="Scroll right">
    <i class="bi bi-chevron-right"></i>
  </button>

</div>

      <!-- ================= END TAB HEADER ================= -->

      <!-- ================= LIST (THIS WAS MISSING) ================= -->
      <div
        class="problems-list"
        *ngIf="tabsProblemList.length > 0; else noProblems">

        <ol class="custom-ol">
          <li class="problem-item" *ngFor="let item of tabsProblemList">
            <a
              class="problem-link"
              href="javascript:void(0)"
              (click)="navigateToProblem($event, item.id)">
              {{ item.title }}
            </a>
          </li>
        </ol>
      </div>

      <ng-template #noProblems>
        <div class="text-center py-5 text-muted">
          No problem statements available.
        </div>
      </ng-template>

    </div>
  </div>
</div>
